import type { ProjectCommentListResponsePageAllOf } from './projectCommentListResponsePageAllOf';
import type { ProjectCommentListResponsePageAllOfThree } from './projectCommentListResponsePageAllOfThree';

export type ProjectCommentListResponsePage = ProjectCommentListResponsePageAllOf & ProjectCommentListResponsePageAllOfThree;
